import { useParams } from "react-router-dom";

import { getIsHMEnabledAndIntegrationEnabled, getIsOccupancyEnabled, useAppSelector } from "@lib/store";
import { useFeatureToggle } from "@hooks";

import { getAvailableTabs, resolveTabRoute } from "./tabs";

export const useAvailableTabs = () => {
  const { WorkspacesOnHereAndNow } = useFeatureToggle();
  const meetingsCalendar = useAppSelector(getIsHMEnabledAndIntegrationEnabled);
  const occupancy = useAppSelector(getIsOccupancyEnabled);

  return getAvailableTabs({ meetingsCalendar, occupancy, workspacesOnHaN: !!WorkspacesOnHereAndNow });
};

export const useHaNTabRoute = () => {
  const { tab } = useParams();
  const availableTabs = useAvailableTabs();

  return resolveTabRoute(tab, availableTabs);
};
